export function LogoMark({ color = "#111111", accent = "#D4AF37", size = 30 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" data-testid="logo-mark" aria-label="JIGEL">
      <circle cx="32" cy="32" r="24" stroke={color} strokeWidth="2.5" strokeDasharray="113 38" strokeLinecap="round" transform="rotate(-45 32 32)" />
      <path d="M50.5 13.5 L32 32" stroke={accent} strokeWidth="2.5" strokeLinecap="round" />
      <circle cx="47" cy="17" r="2.6" stroke={accent} strokeWidth="2.2" fill="none" />
      <path d="M32 32 L30 34" stroke={accent} strokeWidth="2.5" strokeLinecap="round" />
      <circle cx="32" cy="32" r="24" stroke={accent} strokeWidth="2.5" strokeDasharray="14 137" strokeLinecap="round" transform="rotate(135 32 32)" />
    </svg>
  );
}
